import { OperationResult } from '@vp/common/core/OperationResult';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

export abstract class ProfileRepository {
  abstract loadProfile(id: string, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
  abstract activateProfile(id: string, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
  abstract unlockProfile(id: string, code: string, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
}
